import { Badge, Box, Icon, Input, Wrap, WrapItem } from '@chakra-ui/react'
import { FC, KeyboardEvent, useRef, useState } from 'react'
import { MdClose } from 'react-icons/md'

interface Props {
  value: string[]
  onChange: (emails: string[]) => void
  placeholder?: string
}

const EmailChipInput: FC<Props> = ({
  value,
  onChange,
  placeholder = 'email@empresa.com e tecle Enter'
}) => {
  const [input, setInput] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)

  const addEmail = (raw: string) => {
    const email = raw.trim().toLowerCase()
    if (!email || value.includes(email)) {
      setInput('')
      return
    }
    onChange([...value, email])
    setInput('')
  }

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault()
      addEmail(input)
    } else if (e.key === 'Backspace' && !input && value.length > 0) {
      onChange(value.slice(0, -1))
    }
  }

  const removeEmail = (email: string) => {
    onChange(value.filter(e => e !== email))
  }

  return (
    <Box
      borderWidth="1px"
      borderColor="gray.300"
      borderRadius="md"
      px={2}
      py={1}
      minH="40px"
      cursor="text"
      onClick={() => inputRef.current?.focus()}
      _focusWithin={{ borderColor: 'blue.500', boxShadow: '0 0 0 1px #3182ce' }}
    >
      <Wrap spacing={1} align="center">
        {value.map(email => (
          <WrapItem key={email}>
            <Badge
              colorScheme="green"
              borderRadius="full"
              px={2}
              py={0.5}
              fontSize="12px"
              display="flex"
              alignItems="center"
              gap={1}
            >
              {email}
              <Box
                as="span"
                cursor="pointer"
                ml={1}
                onClick={e => {
                  e.stopPropagation()
                  removeEmail(email)
                }}
              >
                <Icon as={MdClose} boxSize={3} />
              </Box>
            </Badge>
          </WrapItem>
        ))}
        <WrapItem flex={1} minW="160px">
          <Input
            ref={inputRef}
            variant="unstyled"
            size="sm"
            value={input}
            onChange={e => setInput(e.target.value)}
            onKeyDown={handleKeyDown}
            onBlur={() => {
              if (input.includes('@')) addEmail(input)
            }}
            placeholder={value.length === 0 ? placeholder : ''}
            fontSize="13px"
            py={1}
          />
        </WrapItem>
      </Wrap>
    </Box>
  )
}

export default EmailChipInput
